import { Field, ID, InputType, Int } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { Task } from '../Task'

@InputType()
export class SortTaskSubTasksArgs extends ActionArgs {
  @Field(() => ID)
  taskId: string

  @Field(() => ID)
  subTaskId: string

  @Field(() => Int)
  sortIndex: number
}

export interface ISortTaskSubTasks extends IAction<Task, SortTaskSubTasksArgs> {}
